import { Header } from '@components/Header';
import { routes } from '@routes';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminUserDetailsPage = () => {
  return (
    <>
      <Helmet>
        <title>User Details - AutoScript Admin</title>
      </Helmet>
      <Header title="User Details" backRoute={routes.adminUsersList.make()} />

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
